var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"back-to-top",attrs:{"href":"#top","id":"backto-top"}},[_c('i',{staticClass:"fal fa-arrow-up"})])}]

export { render, staticRenderFns }